import GroupWorkIcon from "@mui/icons-material/GroupWork";
import WorkspacesOutlinedIcon from "@mui/icons-material/WorkspacesOutlined";
import { SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { TeamModel } from "@snubes/snubes-types";
import { TranslationKey } from "../../Translation/types/TranslationKey";

interface TeamModelType {
  label: TranslationKey;
  caption?: TranslationKey;
  Icon?: OverridableComponent<SvgIconTypeMap>;
}

export const PROVIDER_TEAM_MODEL: Record<TeamModel, TeamModelType> = {
  DEDICATED: {
    label: "ProvderTeamModel_Label_Dedicated",
    caption: "ProvderTeamModel_Caption_Dedicated",
    Icon: GroupWorkIcon,
  },
  SHARED: {
    label: "ProvderTeamModel_Label_Shared",
    caption: "ProvderTeamModel_Caption_Shared",
    Icon: WorkspacesOutlinedIcon,
  },
};
